import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetTodosQuery } from "../rtk/features/api/apiSlice";
import {
  colorRemoved,
  colorSelected,
  setStatus
} from "../rtk/features/filter/filterSlice";

const numberOfTodos = (no_of_todos) => {
  switch (no_of_todos) {
    case 0:
      return "No incomplete task";
    case 1:
      return "1 incomplete task";
    default:
      return `${no_of_todos} incomplete tasks`;
  }
};

export default function Footer() {
  const dispatch = useDispatch();
  const { status, colors: selectedColors } = useSelector(
    (state) => state.filters
  );
  const { data: todos } = useGetTodosQuery('');
  const [todosRemaining, setTodosRemaining] = useState(0);

  useEffect(() => {
    if (todos?.length > 0) {
      let todosIncompleteLength = todos?.filter(
        (todo) => !todo.completed
      ).length;
      setTodosRemaining(todosIncompleteLength);
    }else {
      setTodosRemaining(0);
    }
  }, [todos]);

  const handleStatusChange = (status) => {
    dispatch(setStatus(status));
  };

  const handleColorChange = (color) => {
    if (selectedColors.includes(color)) {
      dispatch(colorRemoved(color));
    } else {
      dispatch(colorSelected(color));
    }
  };
  
  return (
    <div className="mt-4 flex justify-between text-xs text-gray-500">
      <p>{status !== "Complete" && numberOfTodos(todosRemaining)}</p>
      <ul className="flex space-x-1 items-center text-xs">
        <li
          className={`cursor-pointer ${status === "All" && "font-bold"}`}
          onClick={() => handleStatusChange("All")}
        >
          All
        </li>
        <li>|</li>
        <li
          className={`cursor-pointer ${status === "Incomplete" && "font-bold"}`}
          onClick={() => handleStatusChange("Incomplete")}
        >
          Incomplete
        </li>
        <li>|</li>
        <li
          className={`cursor-pointer ${status === "Complete" && "font-bold"}`}
          onClick={() => handleStatusChange("Complete")}
        >
          Complete
        </li>
        <li></li>
        <li></li>
        <li
          className={`h-3 w-3 border-2 border-green-500 md:hover:bg-green-500 rounded-full cursor-pointer ${
            selectedColors.includes("green") && "bg-green-500"
          }`}
          onClick={() => handleColorChange("green")}
        ></li>
        <li
          className={`h-3 w-3 border-2 border-red-500 md:hover:bg-red-500 rounded-full cursor-pointer ${
            selectedColors.includes("red") && "bg-red-500"
          }`}
          onClick={() => handleColorChange("red")}
        ></li>
        <li
          className={`h-3 w-3 border-2 border-yellow-500 md:hover:bg-yellow-500 rounded-full cursor-pointer ${
            selectedColors.includes("yellow") && "bg-yellow-500"
          }`}
          onClick={() => handleColorChange("yellow")}
        ></li>
      </ul>
    </div>
  );
}
